import SecuritySettings from "@/components/shared/settings/sections/SecuritySettings";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";

const AdminSecuritySettings = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Security Settings");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Settings" },
            { label: "Security" },
        ]);
    });

    return <SecuritySettings />;
};

export default AdminSecuritySettings;
